<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  created () {
    if(!this.$store.state.auth && localStorage.getItem('auth')) {
      this.$store.dispatch('logined', localStorage.getItem('token'))
    }

    // 在页面加载时读取sessionStorage
    if (localStorage.getItem('store')) {
      this.$store.replaceState(Object.assign({}, this.$store.state, JSON.parse(localStorage.getItem('store'))))
      localStorage.removeItem("store")
    }
    // 在页面刷新时将store保存到sessionStorage里
    window.addEventListener('beforeunload', () => {
      localStorage.setItem('store', JSON.stringify(this.$store.state))
    })
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/App.vue